import React from "react";

const MAP = {
  active: { label: "Aktif", cls: "bg-[#10B981]/15 text-[#10B981] border-[#10B981]/30" },
  passive: { label: "Pasif", cls: "bg-[#68687B]/15 text-[#A0A0B2] border-[#68687B]/30" },
  frozen: { label: "Donduruldu", cls: "bg-[#3B82F6]/15 text-[#3B82F6] border-[#3B82F6]/30" },
  pending: { label: "Beklemede", cls: "bg-[#F59E0B]/15 text-[#F59E0B] border-[#F59E0B]/30" },
  inactive: { label: "Pasif", cls: "bg-[#68687B]/15 text-[#A0A0B2] border-[#68687B]/30" },
  scheduled: { label: "Planlandı", cls: "bg-[#FF5500]/15 text-[#FF5500] border-[#FF5500]/30" },
  completed: { label: "Tamamlandı", cls: "bg-[#10B981]/15 text-[#10B981] border-[#10B981]/30" },
  cancelled: { label: "İptal", cls: "bg-[#EF4444]/15 text-[#EF4444] border-[#EF4444]/30" },
  no_show: { label: "Gelmedi", cls: "bg-[#EF4444]/15 text-[#EF4444] border-[#EF4444]/30" },
  upcoming: { label: "Yaklaşan", cls: "bg-[#FF5500]/15 text-[#FF5500] border-[#FF5500]/30" },
  new: { label: "Yeni", cls: "bg-[#FF5500]/15 text-[#FF5500] border-[#FF5500]/30" },
  contacted: { label: "İletişimde", cls: "bg-[#3B82F6]/15 text-[#3B82F6] border-[#3B82F6]/30" },
  trial_scheduled: { label: "Deneme Randevusu", cls: "bg-[#F59E0B]/15 text-[#F59E0B] border-[#F59E0B]/30" },
  converted: { label: "Üye Oldu", cls: "bg-[#10B981]/15 text-[#10B981] border-[#10B981]/30" },
  lost: { label: "Kaybedildi", cls: "bg-[#68687B]/15 text-[#A0A0B2] border-[#68687B]/30" },
};

export default function StatusBadge({ status }) {
  const cfg = MAP[status] || { label: status, cls: "bg-[#68687B]/15 text-[#A0A0B2] border-[#68687B]/30" };
  return (
    <span className={`inline-flex items-center text-[11px] font-bold uppercase tracking-wide px-2.5 py-1 rounded-full border ${cfg.cls}`}>
      {cfg.label}
    </span>
  );
}
